import { HelpOutlineOutlined } from "@material-ui/icons";
import ROUTES from "../../../consts/routes.json";
import FAQs from "../../../components/Support/FAQs";

export default {
    component: FAQs,
    id: "support_faqs",
    title: "Frequently asked questions",
    url: ROUTES.SUPPORT_FAQS,
    icon: HelpOutlineOutlined,
};
